{
  "title": "Family Access Code",
  "actions": {
    "copyAria": "Copy family access code",
    "copiedAria": "Copied family access code",
    "copyTitle": "Copy code",
    "copiedTitle": "Copied"
  },
  "share": "Share this with your child",
  "placeholder": "-------"
}
